/* eslint-disable */

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    Abbreviated: [],
    CollectionMetadata: [
      'AccessibleItemCollectionMetadata',
      'ActivationRuleCollectionMetadata',
      'ActiveAlertAcknowledgementCollectionMetadata',
      'ActiveAlertCollectionMetadata',
      'ActiveCardUnitOfferingCollectionMetadata',
      'ActiveTimelineCollectionMetadata',
      'AgencyCollectionMetadata',
      'AgencyLocationCollectionMetadata',
      'AirportCollectionMetadata',
      'AlertCollectionMetadata',
      'ApplicationNotificationCollectionMetadata',
      'ArchiveLogCollectionMetadata',
      'AssignmentDelayedReasonCollectionMetadata',
      'AttachmentCollectionMetadata',
      'AuditLogCollectionMetadata',
      'BaseCollectionMetadata',
      'BaseControlZoneCollectionMetadata',
      'BaseMedicalControlContactCollectionMetadata',
      'BaseMedicalControlContactStateCollectionMetadata',
      'CancellationCategoryCollectionMetadata',
      'CancellationReasonCollectionMetadata',
      'CancellationSecondaryReasonCollectionMetadata',
      'CapabilityCollectionMetadata',
      'CardCollectionMetadata',
      'CardLinkCollectionMetadata',
      'CardNoteArchiveCollectionMetadata',
      'CardNoteCollectionMetadata',
      'CardReOpenReasonCollectionMetadata',
      'CardSearchResultCollectionMetadata',
      'CardSummaryCollectionMetadata',
      'CommunicationCenterCollectionMetadata',
      'CommunicationCenterTransportOfferOptionCollectionMetadata',
      'CompanyCollectionMetadata',
      'CompleteFlightInstanceCollectionMetadata',
      'ConfigurationSettingCollectionMetadata',
      'ControlZoneCollectionMetadata',
      'ConversationCollectionMetadata',
      'ConversationParticipantCollectionMetadata',
      'DeclineCategoryCollectionMetadata',
      'DeclineReasonCollectionMetadata',
      'DeclineSecondaryReasonCollectionMetadata',
      'DepartmentCollectionMetadata',
      'DevNoteCollectionMetadata',
      'DiversionReasonCollectionMetadata',
      'EntityCapabilityCollectionMetadata',
      'EscortRequestCollectionMetadata',
      'EstimatedDurationCollectionMetadata',
      'EtaCollectionMetadata',
      'ExternalActionCollectionMetadata',
      'ExternalActionTypeCollectionMetadata',
      'ExternalReferenceCollectionMetadata',
      'ExternalSystemUnitCollectionMetadata',
      'FacilityNonAcceptanceReasonCollectionMetadata',
      'FboCollectionMetadata',
      'FirewallRuleCollectionMetadata',
      'FlightFollowingReportCollectionMetadata',
      'FuelTankCollectionMetadata',
      'LandingZoneOutOfServiceReasonCollectionMetadata',
      'LocationCollectionMetadata',
      'LocationHazardAttachmentCollectionMetadata',
      'LocationHazardCollectionMetadata',
      'MaintenanceFacilityCollectionMetadata',
      'ManifestEntryCollectionMetadata',
      'MedicalControlContactLogEntryCollectionMetadata',
      'MedicalFacilityCollectionMetadata',
      'MedicalFacilityContactCollectionMetadata',
      'MedicalFacilityPhysicianCollectionMetadata',
      'MedicalFacilityUnitCollectionMetadata',
      'MedicalUnitCollectionMetadata',
      'MessageEnvelopeCollectionMetadata',
      'MessageStatusUpdateCollectionMetadata',
      'NewAgencyLocationRequestCollectionMetadata',
      'NextDueTypeCollectionMetadata',
      'NonReferralReasonCollectionMetadata',
      'NotificationCollectionMetadata',
      'NotificationGroupCollectionMetadata',
      'NotificationGroupMemberCollectionMetadata',
      'NotificationRecipientCollectionMetadata',
      'NotificationSubscriptionCollectionMetadata',
      'NotificationTemplateCollectionMetadata',
      'OemActivityCollectionMetadata',
      'OemAssetCollectionMetadata',
      'OemPlanChangeRequestCollectionMetadata',
      'OemPlanCollectionMetadata',
      'OfferAlgorithmCollectionMetadata',
      'OperationCollectionMetadata',
      'OutOfServiceEventCollectionMetadata',
      'OutOfServiceEventDashboardDataMetadata',
      'OutOfServiceEventNoteCollectionMetadata',
      'OutOfServiceQARReasonCollectionMetadata',
      'OutOfServiceReasonCollectionMetadata',
      'OutOfServiceSecondaryReasonCollectionMetadata',
      'OutOfServiceTicketCollectionMetadata',
      'OutOfServiceTicketDashboardDataMetadata',
      'PaipEventCollectionMetadata',
      'PaipReasonCollectionMetadata',
      'PassdownLogAcknowledgementCollectionMetadata',
      'PassdownLogArchivedLogCollectionMetadata',
      'PassdownLogCollectionMetadata',
      'PatientCollectionMetadata',
      'PersonCollectionMetadata',
      'PhysicianCollectionMetadata',
      'PositionReportAlertCollectionMetadata',
      'PositionReportArchiveCollectionMetadata',
      'PositionReportCollectionMetadata',
      'ProgramBaseCollectionMetadata',
      'ProgramCollectionMetadata',
      'QuestionChoiceCollectionMetadata',
      'QuestionCollectionMetadata',
      'QuestionnaireCollectionMetadata',
      'QuestionnaireQuestionResponseCollectionMetadata',
      'QuestionnaireQuestionResponseNoteCollectionMetadata',
      'QuestionnaireResponseCollectionMetadata',
      'QuestionnaireSectionCollectionMetadata',
      'QuestionnaireSectionQuestionCollectionMetadata',
      'RamcoVehicleConfigurationCollectionMetadata',
      'ReceivingFacilityRequestCollectionMetadata',
      'RegionBaseCollectionMetadata',
      'RegionCollectionMetadata',
      'RegionGroupCollectionMetadata',
      'ReleaseNoteCollectionMetadata',
      'RendezvousRequestCollectionMetadata',
      'RequestCollectionMetadata',
      'RequestLocationCollectionMetadata',
      'RequestPatientCollectionMetadata',
      'RequesterCollectionMetadata',
      'RequesterReferralReasonCollectionMetadata',
      'RequesterRoleCollectionMetadata',
      'SpecialtyTeamCollectionMetadata',
      'SpecialtyTeamMemberCollectionMetadata',
      'StateCollectionMetadata',
      'SupportRequestCollectionMetadata',
      'SystemTimerCollectionMetadata',
      'TimelineCollectionMetadata',
      'TimelineItemCollectionMetadata',
      'TimestampCollectionMetadata',
      'TimestampTypeCollectionMetadata',
      'TimezoneCollectionMetadata',
      'TrackedMessageCollectionMetadata',
      'TransferCenterCollectionMetadata',
      'TransferReasonCollectionMetadata',
      'TransportOfferCollectionMetadata',
      'TransportOfferOptionCollectionMetadata',
      'TransportReasonCollectionMetadata',
      'TripCollectionMetadata',
      'TripLegCollectionMetadata',
      'TripPassengerCollectionMetadata',
      'TrmUserAgencyCollectionMetadata',
      'TrmUserCollectionMetadata',
      'TrmUserMedicalFacilityCollectionMetadata',
      'TrmUserProgramCollectionMetadata',
      'UnitActivationRuleCollectionMetadata',
      'UnitCollectionMetadata',
      'UnitEMSystemMappingCollectionMetadata',
      'UnitNoteCollectionMetadata',
      'UnitNoteResultCollectionMetadata',
      'UnitPositionCollectionMetadata',
      'UnitShiftCollectionMetadata',
      'UnitStatusHistoryEntryCollectionMetadata',
      'UnitSummaryCollectionMetadata',
      'VehicleCollectionMetadata',
      'VehicleConfigurationClassCollectionMetadata',
      'VehicleControlZoneCollectionMetadata',
      'VehicleDispositionCollectionMetadata',
      'VehicleMaintenanceCollectionMetadata',
      'VehicleMakeCollectionMetadata',
      'VehicleModelCollectionMetadata',
      'VehicleNotificationGroupCollectionMetadata',
      'VehiclePositionSummaryCollectionMetadata',
      'VehicleStateInspectionCollectionMetadata',
      'VehicleSummaryCollectionMetadata',
      'WaypointCollectionMetadata',
      'WebOrderLogCollectionMetadata',
    ],
    Entity: [
      'AccessibleItem',
      'ActivationRule',
      'ActiveAlert',
      'ActiveAlertAcknowledgement',
      'ActiveCardUnitOffering',
      'ActiveTimeline',
      'Agency',
      'AgencyLocation',
      'Airport',
      'Alert',
      'ApplicationNotification',
      'ArchiveLog',
      'AssignmentDelayedReason',
      'Attachment',
      'AuditLog',
      'Base',
      'BaseControlZone',
      'BaseMedicalControlContact',
      'BaseMedicalControlContactState',
      'CancellationCategory',
      'CancellationReason',
      'CancellationSecondaryReason',
      'Capability',
      'Card',
      'CardLink',
      'CardNote',
      'CardNoteArchive',
      'CardReOpenReason',
      'CardSummary',
      'CommunicationCenter',
      'CommunicationCenterTransportOfferOption',
      'Company',
      'CompleteFlightInstance',
      'ConfigurationSetting',
      'ControlZone',
      'Conversation',
      'ConversationParticipant',
      'DeclineCategory',
      'DeclineReason',
      'DeclineSecondaryReason',
      'Department',
      'DiversionReason',
      'EntityCapability',
      'EscortRequest',
      'EstimatedDuration',
      'Eta',
      'ExternalAction',
      'ExternalActionType',
      'ExternalReference',
      'ExternalSystemUnit',
      'FacilityNonAcceptanceReason',
      'Fbo',
      'FirewallRule',
      'FlightFollowingReport',
      'FuelTank',
      'LandingZoneOutOfServiceReason',
      'Location',
      'LocationHazard',
      'LocationHazardAttachment',
      'MaintenanceFacility',
      'ManifestEntry',
      'MedicalControlContactLogEntry',
      'MedicalFacility',
      'MedicalFacilityContact',
      'MedicalFacilityPhysician',
      'MedicalFacilityUnit',
      'MedicalUnit',
      'MessageStatusUpdate',
      'NewAgencyLocationRequest',
      'NextDueType',
      'NonReferralReason',
      'Notification',
      'NotificationGroup',
      'NotificationGroupMember',
      'NotificationRecipient',
      'NotificationSubscription',
      'NotificationTemplate',
      'OemActivity',
      'OemAsset',
      'OemPlan',
      'OemPlanChangeRequest',
      'OfferAlgorithm',
      'Operation',
      'OutOfServiceEvent',
      'OutOfServiceEventNote',
      'OutOfServiceQARReason',
      'OutOfServiceReason',
      'OutOfServiceSecondaryReason',
      'OutOfServiceTicket',
      'PaipEvent',
      'PaipReason',
      'PassdownLog',
      'PassdownLogAcknowledgement',
      'PassdownLogArchivedLog',
      'Patient',
      'Person',
      'Physician',
      'PositionReport',
      'PositionReportAlert',
      'PositionReportArchive',
      'Program',
      'ProgramBase',
      'Question',
      'QuestionChoice',
      'Questionnaire',
      'QuestionnaireQuestionResponse',
      'QuestionnaireQuestionResponseNote',
      'QuestionnaireResponse',
      'QuestionnaireSection',
      'QuestionnaireSectionQuestion',
      'RamcoVehicleConfiguration',
      'ReceivingFacilityRequest',
      'Region',
      'RegionBase',
      'RegionGroup',
      'ReleaseNote',
      'RendezvousRequest',
      'Request',
      'RequestLocation',
      'RequestPatient',
      'Requester',
      'RequesterReferralReason',
      'RequesterRole',
      'SpecialtyTeam',
      'SpecialtyTeamMember',
      'State',
      'SupportRequest',
      'SystemTimer',
      'Timeline',
      'TimelineItem',
      'Timestamp',
      'TimestampType',
      'Timezone',
      'TrackedMessage',
      'TransferCenter',
      'TransferReason',
      'TransportOffer',
      'TransportOfferOption',
      'TransportReason',
      'Trip',
      'TripLeg',
      'TripPassenger',
      'TrmUser',
      'TrmUserAgency',
      'TrmUserMedicalFacility',
      'TrmUserProgram',
      'Unit',
      'UnitActivationRule',
      'UnitEMSystemMapping',
      'UnitNote',
      'UnitPosition',
      'UnitShift',
      'UnitStatusHistoryEntry',
      'UnitSummary',
      'Vehicle',
      'VehicleConfigurationClass',
      'VehicleControlZone',
      'VehicleDisposition',
      'VehicleMaintenance',
      'VehicleMake',
      'VehicleModel',
      'VehicleNotificationGroup',
      'VehiclePositionSummary',
      'VehicleStateInspection',
      'VehicleSummary',
      'Waypoint',
      'WebOrderLog',
    ],
    Evented: [
      'AccessibleItem',
      'ActivationRule',
      'ActiveAlert',
      'ActiveAlertAcknowledgement',
      'ActiveCardUnitOffering',
      'ActiveTimeline',
      'Agency',
      'AgencyLocation',
      'Airport',
      'Alert',
      'ApplicationNotification',
      'ArchiveLog',
      'AssignmentDelayedReason',
      'Attachment',
      'AuditLog',
      'Base',
      'BaseControlZone',
      'BaseMedicalControlContact',
      'BaseMedicalControlContactState',
      'CancellationCategory',
      'CancellationReason',
      'CancellationSecondaryReason',
      'Capability',
      'Card',
      'CardLink',
      'CardNote',
      'CardNoteArchive',
      'CardReOpenReason',
      'CardSummary',
      'CommunicationCenter',
      'CommunicationCenterTransportOfferOption',
      'Company',
      'CompleteFlightInstance',
      'ConfigurationSetting',
      'ControlZone',
      'Conversation',
      'ConversationParticipant',
      'DeclineCategory',
      'DeclineReason',
      'DeclineSecondaryReason',
      'Department',
      'DiversionReason',
      'EntityCapability',
      'EscortRequest',
      'EstimatedDuration',
      'Eta',
      'ExternalAction',
      'ExternalActionType',
      'ExternalReference',
      'ExternalSystemUnit',
      'FacilityNonAcceptanceReason',
      'Fbo',
      'FirewallRule',
      'FlightFollowingReport',
      'FuelTank',
      'LandingZoneOutOfServiceReason',
      'Location',
      'LocationHazard',
      'LocationHazardAttachment',
      'MaintenanceFacility',
      'ManifestEntry',
      'MedicalControlContactLogEntry',
      'MedicalFacility',
      'MedicalFacilityContact',
      'MedicalFacilityPhysician',
      'MedicalFacilityUnit',
      'MedicalUnit',
      'MessageStatusUpdate',
      'NewAgencyLocationRequest',
      'NextDueType',
      'NonReferralReason',
      'Notification',
      'NotificationGroup',
      'NotificationGroupMember',
      'NotificationRecipient',
      'NotificationSubscription',
      'NotificationTemplate',
      'OemActivity',
      'OemAsset',
      'OemPlan',
      'OemPlanChangeRequest',
      'OfferAlgorithm',
      'Operation',
      'OutOfServiceEvent',
      'OutOfServiceEventNote',
      'OutOfServiceQARReason',
      'OutOfServiceReason',
      'OutOfServiceSecondaryReason',
      'OutOfServiceTicket',
      'PaipEvent',
      'PaipReason',
      'PassdownLog',
      'PassdownLogAcknowledgement',
      'PassdownLogArchivedLog',
      'Patient',
      'Person',
      'Physician',
      'PositionReport',
      'PositionReportAlert',
      'PositionReportArchive',
      'Program',
      'ProgramBase',
      'Question',
      'QuestionChoice',
      'Questionnaire',
      'QuestionnaireQuestionResponse',
      'QuestionnaireQuestionResponseNote',
      'QuestionnaireResponse',
      'QuestionnaireSection',
      'QuestionnaireSectionQuestion',
      'RamcoVehicleConfiguration',
      'ReceivingFacilityRequest',
      'Region',
      'RegionBase',
      'RegionGroup',
      'ReleaseNote',
      'RendezvousRequest',
      'Request',
      'RequestLocation',
      'RequestPatient',
      'Requester',
      'RequesterReferralReason',
      'RequesterRole',
      'SpecialtyTeam',
      'SpecialtyTeamMember',
      'State',
      'SupportRequest',
      'SystemTimer',
      'Timeline',
      'TimelineItem',
      'Timestamp',
      'TimestampType',
      'Timezone',
      'TrackedMessage',
      'TransferCenter',
      'TransferReason',
      'TransportOffer',
      'TransportOfferOption',
      'TransportReason',
      'Trip',
      'TripLeg',
      'TripPassenger',
      'TrmUser',
      'TrmUserAgency',
      'TrmUserMedicalFacility',
      'TrmUserProgram',
      'Unit',
      'UnitActivationRule',
      'UnitEMSystemMapping',
      'UnitNote',
      'UnitPosition',
      'UnitShift',
      'UnitStatusHistoryEntry',
      'UnitSummary',
      'Vehicle',
      'VehicleConfigurationClass',
      'VehicleControlZone',
      'VehicleDisposition',
      'VehicleMaintenance',
      'VehicleMake',
      'VehicleModel',
      'VehicleNotificationGroup',
      'VehiclePositionSummary',
      'VehicleStateInspection',
      'VehicleSummary',
      'Waypoint',
      'WebOrderLog',
    ],
    Lookup: [],
    TcsEntity: [
      'AccessibleItem',
      'ActivationRule',
      'ActiveAlert',
      'ActiveAlertAcknowledgement',
      'ActiveCardUnitOffering',
      'ActiveTimeline',
      'Agency',
      'AgencyLocation',
      'Airport',
      'Alert',
      'ApplicationNotification',
      'ArchiveLog',
      'AssignmentDelayedReason',
      'Attachment',
      'AuditLog',
      'Base',
      'BaseControlZone',
      'BaseMedicalControlContact',
      'BaseMedicalControlContactState',
      'CancellationCategory',
      'CancellationReason',
      'CancellationSecondaryReason',
      'Capability',
      'Card',
      'CardLink',
      'CardNote',
      'CardNoteArchive',
      'CardReOpenReason',
      'CardSummary',
      'CommunicationCenter',
      'CommunicationCenterTransportOfferOption',
      'Company',
      'CompleteFlightInstance',
      'ConfigurationSetting',
      'ControlZone',
      'Conversation',
      'ConversationParticipant',
      'DeclineCategory',
      'DeclineReason',
      'DeclineSecondaryReason',
      'Department',
      'DiversionReason',
      'EntityCapability',
      'EscortRequest',
      'EstimatedDuration',
      'Eta',
      'ExternalAction',
      'ExternalActionType',
      'ExternalReference',
      'ExternalSystemUnit',
      'FacilityNonAcceptanceReason',
      'Fbo',
      'FirewallRule',
      'FlightFollowingReport',
      'FuelTank',
      'LandingZoneOutOfServiceReason',
      'Location',
      'LocationHazard',
      'LocationHazardAttachment',
      'MaintenanceFacility',
      'ManifestEntry',
      'MedicalControlContactLogEntry',
      'MedicalFacility',
      'MedicalFacilityContact',
      'MedicalFacilityPhysician',
      'MedicalFacilityUnit',
      'MedicalUnit',
      'MessageStatusUpdate',
      'NewAgencyLocationRequest',
      'NextDueType',
      'NonReferralReason',
      'Notification',
      'NotificationGroup',
      'NotificationGroupMember',
      'NotificationRecipient',
      'NotificationSubscription',
      'NotificationTemplate',
      'OemActivity',
      'OemAsset',
      'OemPlan',
      'OemPlanChangeRequest',
      'OfferAlgorithm',
      'Operation',
      'OutOfServiceEvent',
      'OutOfServiceEventNote',
      'OutOfServiceQARReason',
      'OutOfServiceReason',
      'OutOfServiceSecondaryReason',
      'OutOfServiceTicket',
      'PaipEvent',
      'PaipReason',
      'PassdownLog',
      'PassdownLogAcknowledgement',
      'PassdownLogArchivedLog',
      'Patient',
      'Person',
      'Physician',
      'PositionReport',
      'PositionReportAlert',
      'PositionReportArchive',
      'Program',
      'ProgramBase',
      'Question',
      'QuestionChoice',
      'Questionnaire',
      'QuestionnaireQuestionResponse',
      'QuestionnaireQuestionResponseNote',
      'QuestionnaireResponse',
      'QuestionnaireSection',
      'QuestionnaireSectionQuestion',
      'RamcoVehicleConfiguration',
      'ReceivingFacilityRequest',
      'Region',
      'RegionBase',
      'RegionGroup',
      'ReleaseNote',
      'RendezvousRequest',
      'Request',
      'RequestLocation',
      'RequestPatient',
      'Requester',
      'RequesterReferralReason',
      'RequesterRole',
      'SpecialtyTeam',
      'SpecialtyTeamMember',
      'State',
      'SupportRequest',
      'SystemTimer',
      'Timeline',
      'TimelineItem',
      'Timestamp',
      'TimestampType',
      'Timezone',
      'TrackedMessage',
      'TransferCenter',
      'TransferReason',
      'TransportOffer',
      'TransportOfferOption',
      'TransportReason',
      'Trip',
      'TripLeg',
      'TripPassenger',
      'TrmUser',
      'TrmUserAgency',
      'TrmUserMedicalFacility',
      'TrmUserProgram',
      'Unit',
      'UnitActivationRule',
      'UnitEMSystemMapping',
      'UnitNote',
      'UnitPosition',
      'UnitShift',
      'UnitStatusHistoryEntry',
      'UnitSummary',
      'Vehicle',
      'VehicleConfigurationClass',
      'VehicleControlZone',
      'VehicleDisposition',
      'VehicleMaintenance',
      'VehicleMake',
      'VehicleModel',
      'VehicleNotificationGroup',
      'VehiclePositionSummary',
      'VehicleStateInspection',
      'VehicleSummary',
      'Waypoint',
      'WebOrderLog',
    ],
  },
};
export default result;
